import { bindStateToDb } from '@/utilities/db-helpers'
import { compareByProp } from '@/utilities/helpers'
import rounds from './rounds'
import turns from './turns'
import fb from '@/utilities/firebase-config'
const db = fb.database() // alias here so firebase-mock works

export default {
  namespaced: true,

  modules: {
    rounds,
    turns,
  },

  state: {
    isRollingInitiative: false,
    battleCombatants: {},
    meta: {
      round: 1,
      turn: 0,
    },
  },

  getters: {
    orderedCombatants({ battleCombatants }) {
      return Object.keys(battleCombatants || {})
        .sort()
        .map(id => battleCombatants[id])
        .sort(compareByProp(`initiative`))
    },

    combatantIds() {
      return async battleId => {
        const snapshot = await db
          .ref(`/battleCombatants/${battleId}`)
          .once(`value`)
        return snapshot.val()
      }
    },
  },

  actions: {
    bindMetaRef: bindStateToDb(`meta`, `battles`),

    bindCombatantsRef: bindStateToDb(`battleCombatants`, `battleCombatants`),

    update: ({ dispatch, rootGetters }, { id, ...data }) => {
      const updates = {}
      const { uid: owner } = rootGetters[`accounts/user`]

      Object.entries(data).forEach(([key, value]) => {
        updates[`/battles/${id}/${key}`] = value
        if (key === `name`) {
          updates[`/userBattles/${owner}/${id}/${key}`] = value
        }
      })

      return dispatch(`updateDb`, updates, { root: true })
    },

    async beginRollInitiative({ commit }) {
      await commit(`setInitiativeStatus`, true)
      commit(`setInitiativeStatus`, false)
    },
  },

  mutations: {
    setInitiativeStatus: (state, status) =>
      (state.isRollingInitiative = status),
  },
}
